import ReactGA from "react-ga4";
import localStorageService from "helpers/localStorageService";
import { isBlank } from "utils/storeUtils";
export const analyticsService = {
  trackGoogleEvent(action: string, data: Record<string, unknown> = {}) {
    try {
      if (!isBlank(data)) {
        ReactGA.set(data);
      }

      ReactGA.event(`frontend_${action}`, {
        category: "ui_action",
        action: `frontend_${action}`,
        frontendId: localStorageService.get('ero_guest_id'),
        ...data
      });

    } catch (error) {
      throw error;
    }
  },
};
